import {
    LIST_EXAMINATION_RESULT_LABORATORY_REQUEST,
    LIST_EXAMINATION_RESULT_LABORATORY_SUCCESS,
    LIST_EXAMINATION_RESULT_LABORATORY_FAIL,
    LIST_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUMMARY_REQUEST,
    LIST_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUMMARY_SUCCESS,
    LIST_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUMMARY_FAIL,
    TAX_ACTIVIRY_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    TAX_ACTIVIRY_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    TAX_ACTIVIRY_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    LIST_MCU_PATIENT_RESULT_SUMMARY_REQUEST,
    LIST_MCU_PATIENT_RESULT_SUMMARY_SUCCESS,
    LIST_MCU_PATIENT_RESULT_SUMMARY_FAIL,
    DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_TEETH_REQUEST,
    DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_TEETH_SUCCESS,
    DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_TEETH_FAIL,
    ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    UPDATE_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    UPDATE_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    UPDATE_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    CANCEL_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    CANCEL_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    CANCEL_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    ACTION_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    ACTION_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    ACTION_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    TYPE_ACTION_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION,
    RE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    RE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    RE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    GENERATE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    GENERATE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    GENERATE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    SUBMIT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    SUBMIT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    SUBMIT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    HISTORY_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    HISTORY_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    HISTORY_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    PRINT_PREVIEW_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    PRINT_PREVIEW_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    PRINT_PREVIEW_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    CREATE_NEW_RESULT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST,
    CREATE_NEW_RESULT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS,
    CREATE_NEW_RESULT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL,
    LOG_TASK_ACTIVITY_REQUEST,
    LOG_TASK_ACTIVITY_SUCCESS,
    LOG_TASK_ACTIVITY_FAIL,
    SUBMIT_TASK_EXAMINATION_RESULT_LABORATORY_PATIENT_REQUEST,
    SUBMIT_TASK_EXAMINATION_RESULT_LABORATORY_PATIENT_SUCCESS,
    SUBMIT_TASK_EXAMINATION_RESULT_LABORATORY_PATIENT_FAIL,
    IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST,
    IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS,
    IMPORT_VALIDATION_LABORATORY_RESULT_FAIL,
    LIST_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST,
    LIST_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS,
    LIST_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL,
    LIST_DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST,
    LIST_DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS,
    LIST_DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL,
    DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST,
    DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS,
    DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL,
    EXPORT_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST,
    EXPORT_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS,
    EXPORT_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL,
    DOWNLOAD_TEMPLATE_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST,
    DOWNLOAD_TEMPLATE_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS,
    DOWNLOAD_TEMPLATE_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL,
    LIST_EXAMINATION_ATTACHMENT_REQUEST,
    LIST_EXAMINATION_ATTACHMENT_SUCCESS,
    LIST_EXAMINATION_ATTACHMENT_FAIL,
    DELETE_ATTACHMENT_MCU_REQUEST,
    DELETE_ATTACHMENT_MCU_SUCCESS,
    DELETE_ATTACHMENT_MCU_FAIL,
    UPDATE_NOTE_LABORATORY_EXAMINATION_RESULT_REQUEST,
    UPDATE_NOTE_LABORATORY_EXAMINATION_RESULT_SUCCESS,
    UPDATE_NOTE_LABORATORY_EXAMINATION_RESULT_FAIL,
    HISTORY_LOG_LABORATORY_MEDICAL_RESULT_REQUEST,
    HISTORY_LOG_LABORATORY_MEDICAL_RESULT_SUCCESS,
    HISTORY_LOG_LABORATORY_MEDICAL_RESULT_FAIL
} from '../../constants/laboratory'

const initialState = {
    examinationResultList: [],
    pageable: {
        page: 1,
        size: 10
    },
    pageableListDetailImportReview: {
        page: 1,
        size: 10
    },
    examinationItems: [],
    patient: {},
    taxActivities: [],
    loading: false,
    loadingAttachment: false,
    logActivity: {},
    loadingSubmit: false,
    loadingPrint: false,
    error: null,
    loadingTaxActivity: false,
    teeth: {},
    resultSummary: [],
    errorTaxActivity: null,
    loadingDetail: false,
    errorDetail: null,
    typeActionColumn: '',
    examinationItemsAttachment: [],
    LABORATORY: [],
    loadingImport: false,
    loadingImportReview: false,
    loadingExport: false,
    loadingDownloadTemplate: false,
    loadingDetailImport: false,
    loadingDetailImportReview: false,
    importReviewList: [],
    importReviewDetail: {},
    importReviewDetailList: [],
    attachmentLABORATORY: [],
    loadingNote: false,
    loadingAttachment: false,
    historyResult: [],
    loadingHistoryLogPatient: false,
    historyLogPatient: [],
    retryAttempPreview: 0
}

const examinationResultReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBMIT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingSubmit: true
            }
        case SUBMIT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingSubmit: false
            }
        case SUBMIT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingSubmit: false
            }
        case LIST_EXAMINATION_RESULT_LABORATORY_REQUEST:
            return {
                ...state,
                loading: true
            }
        case LIST_EXAMINATION_RESULT_LABORATORY_SUCCESS:
            return {
                ...state,
                loading: false,
                examinationResultList: action.payload,
                pageable: action.pageable,
                error: null
            }
        case LIST_EXAMINATION_RESULT_LABORATORY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUMMARY_REQUEST:
            return {
                ...state,
                loading: true,
                examinationItems: [],
                [action.code]: []
            }
        case LIST_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                examinationItems: action.payload,
                error: null,
                historyResult: action.historyResults,
                [action.code]: action.payload
            }
        case LIST_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUMMARY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                examinationItems: action.dummy,
                LABORATORY: action.dummy
            }
        case LIST_EXAMINATION_ATTACHMENT_REQUEST:
            return {
                ...state,
                loadingAttachment: true,
                examinationItemsAttachment: [],
                [`attachmentLABORATORY`]: []
            }
        case LIST_EXAMINATION_ATTACHMENT_SUCCESS:
            return {
                ...state,
                loadingAttachment: false,
                examinationItemsAttachment: action.payload,
                error: null,
                [`attachmentLABORATORY`]: action.payload
            }
        case LIST_EXAMINATION_ATTACHMENT_FAIL:
            return {
                ...state,
                loadingAttachment: false,
                error: action.payload
            }
        case TAX_ACTIVIRY_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingTaxActivity: true,
                taxActivities: []
            }
        case TAX_ACTIVIRY_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingTaxActivity: false,
                taxActivities: action.payload,
                errorTaxActivity: null
            }
        case TAX_ACTIVIRY_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingTaxActivity: false,
                errorTaxActivity: action.payload,
                taxActivities: action.dummy
            }
        case DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingDetail: true,
                patient: {},
                examinationItems: [],
                taxActivities: [],
                LABORATORY: []
            }
        case DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingDetail: false,
                patient: action.payload,
                errorDetail: null
            }
        case DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingDetail: false,
                errorDetail: action.payload,
                patient: action.dummy
            }
        case LIST_MCU_PATIENT_RESULT_SUMMARY_REQUEST:
            return {
                ...state,
                loading: true
            }
        case LIST_MCU_PATIENT_RESULT_SUMMARY_SUCCESS:
            return {
                ...state,
                loading: false,
                resultSummary: action.payload,
                error: null
            }
        case LIST_MCU_PATIENT_RESULT_SUMMARY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                resultSummary: action.dummy
            }
        case DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_TEETH_REQUEST:
            return {
                ...state,
                loadingDetailTeeth: true
            }
        case DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_TEETH_SUCCESS:
            return {
                ...state,
                loadingDetailTeeth: false,
                teeth: action.payload,
                errorDetailTeeth: null
            }
        case DETAIL_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_TEETH_FAIL:
            return {
                ...state,
                loadingDetailTeeth: false,
                errorDetailTeeth: action.payload,
                teeth: action.dummy
            }
        case UPDATE_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingUpdate: true
            }
        case UPDATE_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingUpdate: false,
                errorUpdate: null
            }
        case UPDATE_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingUpdate: false,
                errorUpdate: action.payload
            }
        case ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingActionSubmit: true
            }
        case ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingActionSubmit: false,
                errorActionSubmit: null
            }
        case ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingActionSubmit: false,
                errorActionSubmit: action.payload
            }
        case CANCEL_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingCancel: true
            }
        case CANCEL_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingCancel: false,
                errorCancel: null
            }
        case CANCEL_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingCancel: false,
                errorCancel: action.payload
            }
        case DELETE_ATTACHMENT_MCU_REQUEST:
            return {
                ...state,
                loadingDelete: true
            }
        case DELETE_ATTACHMENT_MCU_SUCCESS:
            return {
                ...state,
                loadingDelete: false,
                errorCancel: null
            }
        case DELETE_ATTACHMENT_MCU_FAIL:
            return {
                ...state,
                loadingDelete: false,
                errorCancel: action.payload
            }
        case ACTION_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingAction: true
            }
        case ACTION_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingAction: false,
                errorPending: null
            }
        case ACTION_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingAction: false,
                errorPending: action.payload
            }
        case TYPE_ACTION_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION:
            return {
                ...state,
                typeActionColumn: action.payload
            }
        case LOG_TASK_ACTIVITY_REQUEST:
            return {
                ...state,
                logActivity: {}
            }
        case LOG_TASK_ACTIVITY_SUCCESS:
            return {
                ...state,
                logActivity: action.payload
            }
        case LOG_TASK_ACTIVITY_FAIL: {
            return {
                ...state
            }
        }
        case RE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingReItem: true
            }
        case RE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingReItem: false,
                errorReItem: null
            }
        case RE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingReItem: false,
                errorReItem: action.payload
            }
        case GENERATE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingGenerate: true
            }
        case GENERATE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingGenerate: false,
                errorGenerate: null
            }
        case GENERATE_ITEM_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingGenerate: false,
                errorGenerate: action.payload
            }
        case HISTORY_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingHistory: true
            }
        case HISTORY_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingHistory: false,
                historyLog: action.payload,
                errorHistory: null
            }
        case HISTORY_PATIENT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingHistory: false,
                errorHistory: action.payload,
                historyLog: action.dummy
            }
        case PRINT_PREVIEW_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingPrint: true,
                retryAttempPreview: 0
            }
        case PRINT_PREVIEW_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingPrint: false,
                errorPrintPreview: null,
                retryAttempPreview: 0
            }
        case PRINT_PREVIEW_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingPrint: false,
                errorPrintPreview: action.payload,
                retryAttempPreview: 0
            }
        case 'COUNT_REPLY_PRINT_PREIEW':
            return {
                ...state,
                retryAttempPreview: action?.payload
            }
        case CREATE_NEW_RESULT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_REQUEST:
            return {
                ...state,
                loadingCreateNewResult: true
            }
        case CREATE_NEW_RESULT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_SUCCESS:
            return {
                ...state,
                loadingCreateNewResult: false,
                errorCreateNewResult: null
            }
        case CREATE_NEW_RESULT_EXAMINATION_RESULT_LABORATORY_PATIENT_EXAMINATION_FAIL:
            return {
                ...state,
                loadingCreateNewResult: false,
                errorCreateNewResult: action.payload
            }
        case SUBMIT_TASK_EXAMINATION_RESULT_LABORATORY_PATIENT_REQUEST:
            return {
                ...state,
                loadingActionSubmit: true
            }
        case SUBMIT_TASK_EXAMINATION_RESULT_LABORATORY_PATIENT_SUCCESS:
            return {
                ...state,
                loadingActionSubmit: false,
                error: null
            }
        case SUBMIT_TASK_EXAMINATION_RESULT_LABORATORY_PATIENT_FAIL:
            return {
                ...state,
                loadingActionSubmit: false,
                error: action?.payload
            }
        case IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST:
            return {
                ...state,
                loadingImport: true
            }
        case IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS:
            return {
                ...state,
                loadingImport: false,
                error: null
            }
        case IMPORT_VALIDATION_LABORATORY_RESULT_FAIL:
            return {
                ...state,
                loadingImport: false,
                error: action?.payload
            }
        case LIST_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST:
            return {
                ...state,
                loadingImportReview: true
            }
        case LIST_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS:
            return {
                ...state,
                loadingImportReview: false,
                importReviewList: action?.payload,
                pageable: action?.pageable,
                error: null
            }
        case LIST_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL:
            return {
                ...state,
                loadingImportReview: false,
                error: action?.payload,
                importReviewList: action?.dummy
            }
        case LIST_DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST:
            return {
                ...state,
                loadingDetailImportReview: true
            }
        case LIST_DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS:
            return {
                ...state,
                loadingDetailImportReview: false,
                importReviewDetailList: action?.payload,
                pageableListDetailImportReview: action?.pageable,
                error: null
            }
        case LIST_DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL:
            return {
                ...state,
                loadingDetailImportReview: false,
                error: action?.payload,
                importReviewDetailList: action?.dummy
            }
        case DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST:
            return {
                ...state,
                loadingDetailImport: true
            }
        case DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS:
            return {
                ...state,
                loadingDetailImport: false,
                importReviewDetail: action?.payload,
                error: null
            }
        case DETAIL_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL:
            return {
                ...state,
                loadingDetailImport: false,
                error: action?.payload,
                importReviewDetail: action?.dummy
            }
        case EXPORT_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST:
            return {
                ...state,
                loadingExport: true
            }
        case EXPORT_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS:
            return {
                ...state,
                loadingExport: false,
                error: null
            }
        case EXPORT_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL:
            return {
                ...state,
                loadingExport: false,
                error: action?.payload
            }
        case DOWNLOAD_TEMPLATE_IMPORT_VALIDATION_LABORATORY_RESULT_REQUEST:
            return {
                ...state,
                loadingDownloadTemplate: true
            }
        case DOWNLOAD_TEMPLATE_IMPORT_VALIDATION_LABORATORY_RESULT_SUCCESS:
            return {
                ...state,
                loadingDownloadTemplate: false,
                error: null
            }
        case DOWNLOAD_TEMPLATE_IMPORT_VALIDATION_LABORATORY_RESULT_FAIL:
            return {
                ...state,
                loadingDownloadTemplate: false,
                error: action?.payload
            }
        case UPDATE_NOTE_LABORATORY_EXAMINATION_RESULT_REQUEST:
            return {
                ...state,
                loadingNote: true
            }
        case UPDATE_NOTE_LABORATORY_EXAMINATION_RESULT_SUCCESS:
            return {
                ...state,
                loadingNote: false,
                error: null
            }
        case UPDATE_NOTE_LABORATORY_EXAMINATION_RESULT_FAIL:
            return {
                ...state,
                loadingNote: false,
                error: action?.payload
            }
        case HISTORY_LOG_LABORATORY_MEDICAL_RESULT_REQUEST:
            return {
                ...state,
                loadingHistoryLogPatient: true
            }
        case HISTORY_LOG_LABORATORY_MEDICAL_RESULT_SUCCESS:
            return {
                ...state,
                loadingHistoryLogPatient: false,
                historyLogPatient: action?.payload,
                error: null
            }
        case HISTORY_LOG_LABORATORY_MEDICAL_RESULT_FAIL:
            return {
                ...state,
                loadingHistoryLogPatient: false,
                error: action?.payload,
                historyLogPatient: action?.dummy
            }
        default:
            return state
    }
}

export default examinationResultReducer
